<template>
    <div class="qksm qksm11">
        <h4>十一、其他重要事项的情况说明</h4>
        <div class="nogap">
            <h4>（一）机关运行经费情况</h4>
            <p class="hide_pdf">
                （选择单位性质<reason type="select" classname="qksm select " name="单位性质" v-model:value="qksm['单位性质']" optionarr="请选择,行政或参公单位,事业单位"></reason>）<br />
            </p>
            <p>
                <template v-if="qksm['单位性质']=='事业单位'">
                    机关运行经费是指用于维持行政及参照公务员法管理单位机关运行的经费，{{$store.state.divData.divname}}<span v-if="$store.state.divData.type!=0 && isBinzhou">及所属单位均</span>为事业单位，无机关运行经费。{{$parent.year}}年{{$store.state.divData.divname}}<span v-if="$store.state.divData.type!=0 && isBinzhou">及所属单位</span>的事业运行经费
                </template>
                <template v-else>
                    {{$parent.year}}年
                    <reason type="textarea" classname="qksm" name="T11单位名称" v-model:value="qksm['T11单位名称']" v-if="num(qksm['T111单位数量1'])>0"></reason>
                    <template v-if="num(qksm['T111单位数量1']) > 1">
                        、
                        <reason type="textarea" classname="qksm" name="T111单位1" v-model:value="qksm['T111单位1']"></reason>等
                    </template>
                    <reason type="integer" classname="qksm integer must" name="T111单位数量1" v-model:value="qksm['T111单位数量1']"></reason>家行政单位以及
                    <template v-if="num(qksm['T111单位数量2']) > 0 ">
                        <reason type="textarea" classname="qksm" name="T111单位2" v-model:value="qksm['T111单位2']"></reason>等
                    </template>
                    <reason type="integer" classname="qksm integer must" name="T111单位数量2" v-model:value="qksm['T111单位数量2']"></reason>家参公管理事业单位的机关运行经费
                </template>
                财政拨款预算为<reason type="money" classname="qksm money" name="T6机关" v-model:value="T6['机关']"></reason>万元。
                <span class="hide_pdf">
                    （去年预算数<reason type="money" classname="qksm money editLast" name="T6机关last" v-model:value="T6['机关last']"></reason>万元）
                </span>
                <span v-if="num(T6['机关']).toFixed(2)==num(T6['机关last']).toFixed(2)">
                    与{{$store.state.openYear-1}}年预算数相同。
                </span>
                <span v-else>
                    较{{$store.state.openYear-1}}年预算{{growthValueText(T6['机关'],T6['机关last'])}}万元
                    <span v-if="num(T6['机关last'])==0">
                        （去年预算数为0万元，无法计算增减比率）。
                    </span>
                    <span v-else>
                        ，{{growthRatioText(T6['机关'],T6['机关last'])}}。
                    </span>
                    <span class="hide_pdf" v-if="qksm['单位性质']!='事业单位'">
                        <br />
                        <span class="red">主要原因是：办公设施设备购置经费增加（减少）/资产运行维护支出增加（减少）/信息系统运行维护支出增加（减少）/人员编制数量增加（减少）/编制内实有人数增加（减少）/……等（具体增减原因根据本部门实际情况填列）</span>
                        <br />
                    </span>
                    主要原因是<reason type="textarea" classname="qksm widest because" name="T6原因" v-model:value="qksm['T6原因']" :placeholder="qksm['单位性质']=='事业单位' ? '' : '办公设施设备购置经费增加（减少）/资产运行维护支出增加（减少）/信息系统运行维护支出增加（减少）/人员编制数量增加（减少）/编制内实有人数增加（减少）/……等'"></reason>
                </span>
            </p>
            <h4>（二）政府采购情况</h4>
            <p>
                {{$parent.year}}年政府采购预算{{isMoney(T11.总计)}}万元，其中：
                财政拨款安排{{isMoney(T11.财政拨款)}}万元，财政专户管理资金安排{{isMoney(T11.财政专户管理资金)}}万元，单位资金安排{{isMoney(T11.单位资金)}}万元，结余结转资金安排{{isMoney(T11.上年结转)}}万元。
                其中：政府采购货物预算<reason type="money" classname="qksm money" name="政府采购货物" v-model:value="obj.政府采购货物" v-if="num(T11.总计)>0"></reason>{{num(T11.总计)==0 ? 0 : ''}}万元，
                政府采购工程预算<reason type="money" classname="qksm money" name="政府采购工程" v-model:value="obj.政府采购工程" v-if="num(T11.总计)>0"></reason>{{num(T11.总计)==0 ? 0 : ''}}万元，
                政府采购服务预算<reason type="money" classname="qksm money" name="政府采购服务" v-model:value="obj.政府采购服务" v-if="num(T11.总计)>0"></reason>{{num(T11.总计)==0 ? 0 : ''}}万元。
            </p>
            <h4>（三）国有资产占有使用情况</h4>
            <p>
                截至{{$parent.year-1}}年12月31日，{{$store.state.divData.divname}}所属各预算单位共有车辆<reason type="integer" classname="qksm integer must" name="共有车辆" v-model:value="car.共有车辆"></reason>辆，
                其中，实物保障用车<reason type="integer" classname="qksm integer must" name="实物保障用车" v-model:value="car.实物保障用车"></reason>辆、
                机要通信用车<reason type="integer" classname="qksm integer must" name="机要通信用车" v-model:value="car.机要通信用车"></reason>辆、
                应急保障用车<reason type="integer" classname="qksm integer must" name="应急保障用车" v-model:value="car.应急保障用车"></reason>辆、
                行政执法用车<reason type="integer" classname="qksm integer must" name="行政执法用车" v-model:value="car.行政执法用车"></reason>辆、
                执法执勤用车<reason type="integer" classname="qksm integer must" name="执法执勤用车" v-model:value="car.执法执勤用车"></reason>辆、
                特种专业技术用车<reason type="integer" classname="qksm integer must" name="特种专业技术用车" v-model:value="car.特种专业技术用车"></reason>辆、
                离退休干部用车<reason type="integer" classname="qksm integer must" name="离退休干部用车" v-model:value="car.离退休干部用车"></reason>辆、
                事业单位业务用车<reason type="integer" classname="qksm integer must" name="事业单位业务用车" v-model:value="car.事业单位业务用车"></reason>辆、其他用车<reason type="integer" classname="qksm integer must" name="其他用车" v-model:value="car.其他用车"></reason>辆。
                <span v-if="num(car.其他用车)>0">
                     其中，其他用车主要是
                    <reason type="textarea" classname="qksm widest" name="其他用车主要是" v-model:value="qksm['其他用车主要是']"></reason>
                </span>
            </p>
            <p>
                单位价值50万元以上通用设备<reason type="integer" classname="qksm integer must" name="通用设备" v-model:value="qksm['通用设备']"></reason>台（件、套），
                单位价值100万元以上专用设备<reason type="integer" classname="qksm integer must" name="专用设备" v-model:value="qksm['专用设备']"></reason>台（件、套）。
            </p>
            <p>
                <span v-if="isPdf && num(qksm['安排通用设备'])==0">
                    {{$parent.year}}年{{isBinzhou && $store.state.divData.type==0 ? '' : (isDezhou && $store.state.divData.type==0 ? '单位' : '部门')}}预算未安排购置单位价值50万元以上通用设备
                </span>
                <span v-else>
                    {{$parent.year}}年{{isBinzhou && $store.state.divData.type==0 ? '' : (isDezhou && $store.state.divData.type==0 ? '单位' : '部门')}}预算安排购置单位价值50万元以上通用设备<reason type="integer" classname="qksm integer must" name="安排通用设备" v-model:value="qksm['安排通用设备']"></reason>台（件、套）
                </span>
                ，
                <span v-if="isPdf && num(qksm['安排专用设备'])==0">
                    {{$parent.year}}年{{isBinzhou && $store.state.divData.type==0 ? '' : (isDezhou && $store.state.divData.type==0 ? '单位' : '部门')}}预算未安排购置单位价值100万元以上专用设备。
                </span>
                <span v-else>
                   单位价值100万元以上专用设备<reason type="integer" classname="qksm integer must" name="安排专用设备" v-model:value="qksm['安排专用设备']"></reason>台（件、套）。
                </span>
            </p>
        </div>
        <p></p>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm11",
        components: {
            reason,
        },
        props: {
            T6: {
                type: Object,
                default: "",
            },
            T11: {
                type: Object,
                default: "",
            },

        },
        data() {
            var qksm = this.$store.state.divData.qksm
            var zone = this.$store.state.divData.zone
            let isBinzhou = zone.indexOf('binzhou') > -1 || zone == 'bincheng' || zone == 'zhanhua' ? true : false
            let isDezhou = zone == 'dezhou' || zone == 'decheng' || zone == 'pingyuan' || zone == 'qingyun' || zone == 'laoling' || zone == 'ningjin' || zone == 'lingcheng' || zone == 'linyi' || zone == 'wucheng' || zone == 'yucheng' || zone == 'xiajin' || zone == 'qihe' ? true : false
            if (qksm['T6机关'])
                this.T6['机关'] = qksm['T6机关'];
            if (qksm['T6机关last'])
                this.T6['机关last'] = qksm['T6机关last'];
            qksm['T111单位数量1'] = this.pickOneOf(qksm['T111单位数量1'], 1)
            var arr = ["共有车辆", "实物保障用车", "机要通信用车", "应急保障用车","行政执法用车", "执法执勤用车", "执法执勤用车", "特种专业技术用车", "离退休干部用车", "事业单位业务用车","其他用车"]
            var car = [];
            for (var i = 0; i < arr.length; i++) {
                car[arr[i]] = qksm[arr[i]]
            }
            if (!qksm['T11单位名称']) {
                qksm['T11单位名称'] = this.$store.state.divData.divname
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
                car: car,
                obj: {
                    政府采购总计: this.T11.总计,
                    政府采购货物: qksm['政府采购货物'],
                    政府采购工程: qksm['政府采购工程'],
                    政府采购服务: qksm['政府采购服务'],
                },
                isBinzhou: isBinzhou,
                isDezhou: isDezhou,
                zone: zone,
            }
        },
        created() {
            this.inspect()
        },
        updated: function () {
            this.inspect()
        },
        methods: {
            inspect() {
                var obj = Object.values(this.obj)
                var sum = 0;
                for (var i = 1; i < obj.length; i++) {
                    sum = sum + this.num(obj[i])
                }
                if (this.num(obj[0])>0 && this.num(obj[0]).toFixed(2) != this.num(sum).toFixed(2)) {
                    this.addOrSet("qksm112", "请检查本页《十一、其他重要事项的情况说明》中（二）政府采购情况，政府采购货物预算金额+政府采购工程预算金额+各政府采购服务预算金额应该等于政府采购预算总额。");
                } else {
                    this.remove("qksm112")
                }
                var arr = Object.values(this.car)
                sum = 0;
                for (var i = 1; i < arr.length; i++) {
                    sum = sum + this.num(arr[i])
                }
                if (this.num(arr[0]).toFixed(2) != this.num(sum).toFixed(2)) {
                    this.addOrSet("qksm113", "请检查本页《十一、其他重要事项的情况说明》中（三）国有资产占有使用情况，各项车辆使用情况总和应该等于单位拥有车辆总数。");
                } else {
                    this.remove("qksm113")
                }
            }
        }
    };
</script>
<style scoped>
    .upload {
        color: #9ECADF;
        font-weight: 600;
    }
</style>